import { useEffect, useState } from 'react';
import { SunIcon, MoonIcon } from './icons';
import { useT } from '../lib/i18n';

type Theme = 'dark' | 'light';

const STORAGE_KEY = 'kardolive-theme';

function readTheme(): Theme {
  let v: string | null = null;
  try { v = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null; } catch { /* Private/embedded browsers can deny storage. */ }
  if (v === 'light' || v === 'dark') return v;
  if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: light)').matches) return 'light';
  return 'dark';
}

function applyTheme(t: Theme) {
  document.documentElement.setAttribute('data-theme', t);
}

export function ThemeToggle() {
  const { t } = useT();
  const [theme, setTheme] = useState<Theme>(() => readTheme());

  useEffect(() => {
    applyTheme(theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* Keep the selected appearance for this visit. */ }
  }, [theme]);

  const next: Theme = theme === 'dark' ? 'light' : 'dark';
  return (
    <button
      className="theme-toggle"
      onClick={() => setTheme(next)}
      title={t('theme.' + next)}
      aria-label={t('theme.' + next)}
    >
      {theme === 'dark' ? <SunIcon size={16}/> : <MoonIcon size={16}/>}
    </button>
  );
}
